module.exports = __webpack_public_path__ + "static/media/latvia.e0713417.svg";